import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './_styles_/DefaultCashLimitsTable.css';
import { useTranslation } from 'react-i18next';
import DefaultCashLimitRow from './DefaultCashLimitRow';
import { defaultCashLimitsType } from '../../types';
import useAuthentication from '../../hooks/useAuthentication';
import { hasPrivilege } from '../../hocs/withPrivileges';
import Privileges from '../../utils/Privileges';
import ResetFieldButton from '../buttons/ResetFieldButton';

DefaultCashLimitsTable.propTypes = {
    minCashLimit: PropTypes.number,
    maxCashLimit: PropTypes.number,
    defaultCashLimits: defaultCashLimitsType.isRequired,
    onDefaultCashLimitChange: PropTypes.func.isRequired,
    canBeEdited: PropTypes.bool,
    onReset: PropTypes.func.isRequired,
    isChanged: PropTypes.bool.isRequired,
    doResetComponentsAfterModification: PropTypes.bool,
};

DefaultCashLimitsTable.defaultProps = {
    minCashLimit: null,
    maxCashLimit: null,
    canBeEdited: true,
    doResetComponentsAfterModification: false,
};

function DefaultCashLimitsTable(props) {
    const {
        minCashLimit,
        maxCashLimit,
        defaultCashLimits,
        onDefaultCashLimitChange,
        canBeEdited,
        onReset,
        isChanged,
        doResetComponentsAfterModification,
    } = props;
    const { t } = useTranslation();
    const [doReset, setDoReset] = useState(false);
    const { userPrivileges } = useAuthentication();
    const isEditable = canBeEdited && hasPrivilege(userPrivileges, [Privileges.CLEARING_HOUSE_EDIT]);
    const onResetInternal = () => {
        setDoReset(true);
        onReset();
    };
    return (
        <div className={`default-cash-limits-table field${isEditable ? '' : ' readonly'}${isChanged ? ' modified' : ''}`}>
            <div className="default-cash-limits-field">
                <span className="field--key">{t('clearing-houses.default-cash-limits')}</span>
                <div className="detail-list">
                    <div className="detail-list-row detail-list-header">
                        <div className="default-cash-limit-cell">{t('clearing-houses.cash-limits.currency-name')}</div>
                        <div className="default-cash-limit-cell">{t('clearing-houses.cash-limits.currency-code')}</div>
                        <div className="default-cash-limit-cell">{t('clearing-houses.cash-limits.default-cash-limit')}</div>
                    </div>
                    {defaultCashLimits.map((defaultCashLimit) => (
                        <DefaultCashLimitRow
                            key={defaultCashLimit.currencyCode}
                            minCashLimit={minCashLimit}
                            maxCashLimit={maxCashLimit}
                            defaultCashLimit={defaultCashLimit}
                            onCashLimitChange={onDefaultCashLimitChange}
                            canBeEdited={canBeEdited}
                            doReset={doReset}
                            doResetComponentsAfterModification={doResetComponentsAfterModification}
                        />
                    ))}
                </div>
            </div>
            {isChanged && onReset && <ResetFieldButton onReset={onResetInternal} />}
        </div>
    );
}

export default DefaultCashLimitsTable;
